import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import submitForm from './components/submitForm';
import Form from './components/Form';
import { actionCreators } from '../../actions';
import validateForm from './components/validateForm';

const FindDelivery = ({ next }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const deliveriesState = useSelector(state => state.deliveries);

  const methods = useForm({
    defaultValues: {
      deliveryId: '',
      mobileNo: ''
    },
    mode: 'onBlur',
    reValidateMode: 'onChange',
    resolver: async (values) => {
      const errors = validateForm(values);
      return {
        values: Object.keys(errors).length === 0 ? values : {},
        errors
      };
    }
  });

  const { setValue, trigger, setError } = methods;

  useEffect(() => {
    const deliveryId = searchParams.get('id');
    if (deliveryId) {
      setValue('deliveryId', deliveryId);
      trigger('deliveryId'); // Trigger validation for the field
      dispatch(actionCreators.getUserPermissions(deliveryId));
    }
  }, [searchParams, setValue, trigger, dispatch]);

  const onSubmit = async (values) => {
    try {
      await submitForm(values, next, dispatch, setError);
    } catch (err) {
      console.error('Form submission failed:', err);
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={onSubmit} deliveriesState={deliveriesState} />
    </FormProvider>
  );
};

export default FindDelivery;
